'use strict'

var angular = require('angular')
require('../css/main.less')

// require bootstrap components
var dropdownComponent = require('angular-ui-bootstrap/src/dropdown')
var alertComponent = require('angular-ui-bootstrap/src/alert')
var modalComponent = require('angular-ui-bootstrap/src/modal')

var app = angular.module('app', [
  require('angular-route'),
  require('angular-cookies'),
  require('angular-loading-bar'),
  require('angular-sanitize'),
  require('ng-file-upload'),
  require('ng-img-crop-npm'),
  require('satellizer'),
  require('angular-google-analytics'),
  dropdownComponent,
  alertComponent,
  modalComponent,
  require('angular-translate'),
  require('angular-translate-loader-static-files')
])

require('./services')(app)
require('./controllers')(app)
require('./directives')(app)
require('./filters')(app)

app
  .config(["$routeProvider", "$locationProvider", "$logProvider", "$provide", "$httpProvider", "$authProvider", "cfpLoadingBarProvider", "AnalyticsProvider", "$translateProvider", function ($routeProvider, $locationProvider, $logProvider, $provide, $httpProvider, $authProvider, cfpLoadingBarProvider, AnalyticsProvider, $translateProvider) {
    // Priority:
    // 1. ?lang=<lang>
    // 2. window.navigator.language.toLowerCase()
    var LANG

    var LANG_PARAM = new window.URLSearchParams(window.location.search).get('lang')
    var LANG_LOCALSTORAGE = window.localStorage.getItem('PG_LANG')
    var LANG_NAVIGATOR = window.navigator.language.toLowerCase()

    LANG = LANG_PARAM || LANG_NAVIGATOR || 'en-us'

    if (!LANG_LOCALSTORAGE || (LANG_PARAM && LANG_LOCALSTORAGE)) {
      window.localStorage.setItem('PG_LANG', LANG)
    }

    if (LANG_LOCALSTORAGE === 'null') {
      // BUG LANG_LOCALSTORAGE = null at 2018/07/31
      window.localStorage.setItem('PG_LANG', 'en-us')
    }

    $translateProvider.useStaticFilesLoader({
      prefix: '/translations/',
      suffix: '.json'
    }).preferredLanguage(LANG).fallbackLanguage('en-us')

    $translateProvider.useSanitizeValueStrategy('sce')

    // IE cache cleaner
    // http://www.oodlestechnologies.com/blogs/AngularJS-caching-issue-for-Internet-Explorer
    $httpProvider.defaults.cache = false
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {}
    }
    $httpProvider.defaults.headers.get['If-Modified-Since'] = '0'

    // angular google analytics
    AnalyticsProvider.setAccount(__gaKey__)
    AnalyticsProvider.trackPages(true)
    AnalyticsProvider.ignoreFirstPageLoad(true)
    AnalyticsProvider.useECommerce(true, true)
    AnalyticsProvider.useCrossDomainLinker(true)
    AnalyticsProvider.setCrossLinkDomains([__bcHost__])

    $routeProvider
      .when('/', {
        templateUrl: 'template/main.html',
        controller: 'LandingCtrl',
        resolve: {
          checkAuth: ["$rootScope", "$q", "$location", "$log", "Auth", function ($rootScope, $q, $location, $log, Auth) {
            var deferred = $q.defer()
            Auth.checkLoginStatus()
              .then(function () {
                Auth.logoutUser()
                $location.path('/login')
                deferred.reject(new Error('Did not login'))
              })
              .catch(function () {
                deferred.reject()
              })
            return deferred.promise
          }]
        }
      })
      .when('/profile', {
        templateUrl: 'template/profile.html',
        controller: 'MainCtrl',
        resolve: {
          UserData: ["$rootScope", "$q", "$location", "$log", "Auth", function ($rootScope, $q, $location, $log, Auth) {
            var deferred = $q.defer()
            if (!Auth.isLoggedIn()) {
              Auth.logoutUser()
              $location.path('/login')
              deferred.reject(new Error('Did not login'))
            } else {
              Auth.getUser()
                .then(function (resp) {
                  $log.debug('UserData', resp)
                  if (resp && resp.data) {
                    deferred.resolve(resp.data)
                  } else {
                    Auth.logoutUser()
                    $location.path('/login')
                    deferred.reject(new Error('Can not get user data'))
                  }
                })
                .catch(function (err) {
                  $log.debug('UserData:Error', err)
                  Auth.logoutUser()
                  $location.path('/login')
                  deferred.reject(err)
                })
            }
            return deferred.promise
          }]
        }
      })
      .when('/oauth/callback', {
        templateUrl: 'template/blank.html',
        controller: 'CallbackCtrl'
      })
      .when('/login', {
        templateUrl: 'template/login.html',
        controller: 'AuthCtrl'
      })
      .when('/signup', {
        templateUrl: 'template/signup.html',
        controller: 'AuthCtrl'
      })
      // .when('/b2b_signup', {
      //   templateUrl: 'template/b2b-signup.html',
      //   controller: 'AuthCtrl'
      // })
      .when('/store_signup', {
        templateUrl: 'template/store-signup.html',
        controller: 'AuthCtrl',
        resolve: {
          checkSignup: ["$q", "Auth", function ($q, Auth) {
            var deferred = $q.defer()
            Auth.clearCredentials()
            deferred.resolve()
            return deferred.promise
          }]
        }
      })
      .when('/store_auth', {
        templateUrl: 'template/store-auth.html',
        controller: 'AuthCtrl',
        resolve: {
          checkLogin: ["$q", "$window", "$location", "Auth", "$log", function ($q, $window, $location, Auth, $log) {
            var deferred = $q.defer()
            Auth.clearCredentials()
            deferred.resolve()
            return deferred.promise
          }]
        }
      })
      .when('/update_profile', {
        templateUrl: 'template/update-profile.html',
        controller: 'MigrateProfileCtrl'
      })
      .when('/activate', {
        templateUrl: 'template/account-activation.html',
        controller: 'ActivateCtrl',
        resolve: {
          ActivateData: ["$rootScope", "$q", "$location", "$log", "Auth", function ($rootScope, $q, $location, $log, Auth) {
            var deferred = $q.defer()
            var params = $location.search()
            $log.debug('route:activate', params)

            if (!params.email || !params.token) {
              $location.path('/login')
              deferred.resolve({
                result: 'INVALID'
              })
            } else {
              Auth.userActivation({
                email: params.email,
                token: params.token
              })
                .then(function (resp) {
                  var message = resp.data.message
                    ? resp.data.message
                    : 'Activation Success'
                  deferred.resolve({
                    result: 'SUCCESS',
                    email: params.email,
                    message: message
                  })
                })
                .catch(function (err) {
                  var message = err.data.errorMessage
                    ? err.data.errorMessage
                    : 'Activation Failed'
                  deferred.resolve({
                    result: 'FALSE',
                    email: params.email,
                    message: message
                  })
                })
            }
            return deferred.promise
          }]
        }
      })
      .when('/req_password', {
        templateUrl: 'template/req-password.html',
        controller: 'ReqPasswordCtrl'
      })
      .when('/reset_password', {
        templateUrl: 'template/password-reset.html',
        controller: 'PasswordResetCtrl'
      })
      .when('/blank', {
        templateUrl: 'template/blank.html'
      })
      .when('/redeem', {
        templateUrl: 'template/redeem.html',
        controller: 'RedeemCtrl',
        resolve: {
          redeemData: ["$q", "$http", "$log", "$location", "Auth", function ($q, $http, $log, $location, Auth) {
            var deferred = $q.defer()
            Auth.checkLoginStatus()
              .then(function () {
                return deferred.resolve([])
              })
              .catch(function () {
                deferred.reject()
                return $location.path('/login').search('redirect', 'redeem')
              })
            return deferred.promise
          }]
        }
      })
      .when('/presonus-spark', {
        templateUrl: 'template/presonus.html',
        controller: 'PresonusCtrl',
        resolve: {
          redeemData: ["$q", "$http", "$log", "$window", "$location", "Auth", function ($q, $http, $log, $window, $location, Auth) {
            var deferred = $q.defer()
            var allQueryParameter = $location.search()
            $log.debug('all', allQueryParameter)

            var oldSiteHost = $location.host()
            var redirectTo = ''
            if (/^pg-usercenter-staging/.test(oldSiteHost)) {
              redirectTo = 'https://member-sandbox.positivegrid.com/presonus-spark'
            } else {
              redirectTo = 'https://member.positivegrid.com/presonus-spark'
            }

            var allParams = _.map(allQueryParameter, function (qsV, qsK) {
              return qsK + "=" + qsV
            })

            $log.debug('redirect', redirectTo, allParams, $window)
            if (!_.isEmpty(allParams)) {
              deferred.resolve([])
              return $window.location.href = redirectTo + "?" + allParams.join('&')
            } else {
              deferred.resolve([])
              return $window.location.href = redirectTo
            }
            return deferred.promise
          }]
        }
      })
      .when('/apogee', {
        templateUrl: 'template/redeem-apogee.html',
        controller: 'RedeemCtrl',
        resolve: {
          redeemData: ["$q", "$http", "$log", "$location", "Auth", function ($q, $http, $log, $location, Auth) {
            var deferred = $q.defer()
            deferred.resolve([])
            return deferred.promise
          }]
        }
      })
      .when('/checkout', {
        templateUrl: 'template/checkout.html',
        controller: 'AuthCtrl'
      })
      .otherwise({
        redirectTo: '/login'
      })

    // use html5 mode
    $locationProvider.html5Mode(true).hashPrefix('!')

    // turn on/off debug messages
    $logProvider.debugEnabled(__f2eDebug__)

    // angular loading bar
    cfpLoadingBarProvider.latencyThreshold = 200
    cfpLoadingBarProvider.includeSpinner = false
    cfpLoadingBarProvider.includeBar = true

    // satellizer
    $authProvider.tokenType = 'JWT'
    $authProvider.tokenHeader = 'Authorization'
    $authProvider.storageType = 'localStorage'
    $authProvider.facebook({
      name: 'facebook',
      clientId: '254294421583037',
      authorizationEndpoint: 'https://www.facebook.com/v2.10/dialog/oauth',
      url: '/api/oauth/facebook',
      redirectUri: window.location.origin + '/blank',
      requiredUrlParams: ['display', 'scope'],
      scope: ['email', 'public_profile'],
      scopeDelimiter: ',',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: { width: 580, height: 400 }
    })
    $authProvider.google({
      name: 'google',
      url: '/api/oauth/google',
      clientId: '497690279039-9bnnjngjebanane2fd1se0g6b3bd2pri.apps.googleusercontent.com',
      authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
      redirectUri: window.location.origin,
      requiredUrlParams: ['scope'],
      optionalUrlParams: ['display'],
      scope: ['profile', 'email'],
      scopePrefix: 'openid',
      scopeDelimiter: ' ',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: { width: 452, height: 633 }
    })
  }])
  .run(["$rootScope", "$location", "$log", "$window", "Auth", "Analytics", function ($rootScope, $location, $log, $window, Auth, Analytics) {
    // facebook pixel
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'
      n.queue = []; t = b.createElement(e); t.async = !0
      t.src = v; s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'))
    $window.fbq('init', __fb_pixel_id__)
    $window.fbq('track', 'PageView')

    // exponea
    !function (e, n, t, i, o, r) { function c(e) { if ("number" != typeof e) return e; var n = new Date; return new Date(n.getTime() + 1e3 * e) } var a = 4e3, s = "xnpe_async_hide"; function p(e) { return e.reduce((function (e, n) { return e[n] = function () { e._.push([n.toString(), arguments]) }, e }), { _: [] }) } function m(e, n, t) { var i = t.createElement(n); i.src = e; var o = t.getElementsByTagName(n)[0]; return o.parentNode.insertBefore(i, o), i } function u(e) { return "[object Date]" === Object.prototype.toString.call(e) } r.target = r.target || "https://api.exponea.com", r.file_path = r.file_path || r.target + "/js/exponea.min.js", o[n] = p(["anonymize", "initialize", "identify", "update", "track", "trackLink", "trackEnhancedEcommerce", "getHtml", "showHtml", "showBanner", "showWebLayer", "ping", "getAbTest", "loadDependency", "getRecommendation", "reloadWebLayers"]), o[n].notifications = p(["isAvailable", "isSubscribed", "subscribe", "unsubscribe"]), o[n]["snippetVersion"] = "v2.3.0", function (e, n, t) { e[n]["_" + t] = {}, e[n]["_" + t].nowFn = Date.now, e[n]["_" + t].snippetStartTime = e[n]["_" + t].nowFn() }(o, n, "performance"), function (e, n, t, i, o, r) { e[o] = { sdk: e[i], sdkObjectName: i, skipExperiments: !!t.new_experiments, sign: t.token + "/" + (r.exec(n.cookie) || ["", "new"])[1], path: t.target } }(o, e, r, n, i, RegExp("__exponea_etc__" + "=([\\w-]+)")), function (e, n, t) { m(e.file_path, n, t) }(r, t, e), function (e, n, t, i, o, r, p) { if (e.new_experiments) { !0 === e.new_experiments && (e.new_experiments = {}); var f, l = e.new_experiments.hide_class || s, _ = e.new_experiments.timeout || a, d = encodeURIComponent(r.location.href.split("#")[0]); e.cookies && e.cookies.expires && ("number" == typeof e.cookies.expires || u(e.cookies.expires) ? f = c(e.cookies.expires) : e.cookies.expires.tracking && ("number" == typeof e.cookies.expires.tracking || u(e.cookies.expires.tracking)) && (f = c(e.cookies.expires.tracking))), f && f < new Date && (f = void 0); var x = e.target + "/webxp/" + n + "/" + r[t].sign + "/modifications.min.js?http-referer=" + d + "&timeout=" + _ + "ms" + (f ? "&cookie-expires=" + Math.floor(f.getTime() / 1e3) : ""); "sync" === e.new_experiments.mode && r.localStorage.getItem("__exponea__sync_modifications__") ? function (e, n, t, i, o) { t[o][n] = "<" + n + ' src="' + e + '"></' + n + ">", i.writeln(t[o][n]), i.writeln("<" + n + ">!" + o + ".init && document.writeln(" + o + "." + n + '.replace("/' + n + '/", "/' + n + '-async/").replace("><", " async><"))</' + n + ">") }(x, n, r, p, t) : function (e, n, t, i, o, r, c, a) { r.documentElement.classList.add(e); var s = m(t, i, r); function p() { o[a].init || m(t.replace("/" + i + "/", "/" + i + "-async/"), i, r) } function u() { r.documentElement.classList.remove(e) } s.onload = p, s.onerror = p, o.setTimeout(u, n), o[c]._revealPage = u }(l, _, x, n, r, p, o, t) } }(r, t, i, 0, n, o, e), function (e, n, t) { e[n].start = function (i) { i && Object.keys(i).forEach((function (e) { return t[e] = i[e] })), e[n].initialize(t) } }(o, n, r) }(document, "exponea", "script", "webxpClient", window, {
      target: "https://api.us1.exponea.com",
      token: "70793ed4-a764-11eb-a388-92825d567adf",
      // replace with current customer ID or leave commented out for an anonymous customer
      // customer: window.currentUserId,
    });
    $window.exponea.start();

    $rootScope.$on('$routeChangeStart', function (event, next, current) {
      $log.debug('routeChangeStart', event, next, current)

      var allowPath = ['signup', 'login', 'activate', 'reset_password', 'req_password', 'store_auth', 'store_signup', 'b2b_signup', 'oauth/authorization', 'blank', 'oauth/callback', 'checkout', 'presonus-spark']
      var gotoPath
      if (next && next.$$route && next.$$route.originalPath) {
        gotoPath = next.$$route.originalPath.replace('/', '')
      }
      $log.debug('gotoPath: ', gotoPath)
      // FIXME Rewrite this
      if (gotoPath === 'store_auth' || gotoPath === 'store_signup' || gotoPath === 'apogee' || gotoPath === 'checkout') {
        return $location.path(gotoPath)
      } else if (!Auth.isLoggedIn()) {
        if (gotoPath && gotoPath.match('redeem')) {
          return $location.path('/login').search('redirect', 'redeem')
        } else if (gotoPath && gotoPath.match('referral')) {
          return $location.path('/login').search('redirect', 'referral')
        } else if (gotoPath && gotoPath.match('apogee')) {
          return $location.path('/login').search('redirect', 'apogee')
        } else if (allowPath.indexOf(gotoPath) === -1) {
          return $location.path('/login')
        } else {
          return $location.path(gotoPath)
        }
      } else {
        if (gotoPath && gotoPath.match('redeem')) {
          $location.path('redeem')
        } else if (gotoPath && gotoPath.match('update_profile')) {
          $location.path('update_profile')
        } else if (gotoPath && gotoPath.match('blank')) {
          $location.path('blank')
        } else if (gotoPath && gotoPath.match('referral')) {
          $location.path('referral')
        } else if (gotoPath && gotoPath.match('apogee')) {
          $location.path('apogee')
        } else {
          $location.path('/profile')
        }
      }
    })
  }])



//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = 49
// module chunks = 0